
import moment from 'jalali-moment';


export const convertToGregorian = (persianDate) => {
    const date = moment.from(persianDate, 'fa', 'jYYYY/jMM/jDD');
    return date.format('YYYY-MM-DD');
};